import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { DatePickerMondayFirst } from '../../utils/date-picker-monday-first';
import { MatDatepicker } from '@angular/material/datepicker';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  standalone: false,
  providers: [{ provide: DateAdapter, useClass: DatePickerMondayFirst }],
})
export class DatePickerComponent implements OnInit, OnChanges {
  @ViewChild('dpFormCtrl', { static: false }) public dpFormCtrl!: MatDatepicker<Date>;

  @ViewChild('dpNgModel', { static: false }) public dpNgModel!: MatDatepicker<Date>;

  @ViewChild('dpNoFilterFormCtrl', { static: false }) public dpNoFilterFormCtrl!: MatDatepicker<Date>;

  @ViewChild('dpNoFilterNgModel', { static: false }) public dpNoFilterNgModel!: MatDatepicker<Date>;

  @Input() public formCtrl: FormControl | undefined;

  @Input() public fromMon2Fri: boolean | undefined;

  @Input() public day: Date | string | undefined;

  @Input() public placeholder = '';

  @Input() public disabled = false;

  @Input() public isOnlyMonday = false;

  @Input() public isOnlyFriday = false;

  @Input() public isTodayMinDate = false;

  @Input() public isTwoWeeksMaxDate = false;

  @Input() public maxDate: Date | null = null;

  @Input() public isNextWeekMinDate = false;

  @Input() public minDate: Date | null = null;

  @Output() public dateChanged = new EventEmitter();

  public todayDate = new Date();

  public nextWeekDate = new Date();

  public twoWeeksDate = new Date();

  constructor() {}

  ngOnInit() {
    if (this.isNextWeekMinDate) {
      this.nextWeekDate.setDate(this.nextWeekDate.getDate() + 7);
    }
    if (this.isTwoWeeksMaxDate) {
      this.populateTwoWeeksDate();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['minDate'] && changes['minDate'].currentValue) {
      if (
        changes['minDate'].currentValue != changes['minDate'].previousValue &&
        changes['minDate'].currentValue != this.todayDate
      ) {
        this.nextWeekDate = changes['minDate'].currentValue;
      }
    }
    if (this.isTwoWeeksMaxDate) {
      this.populateTwoWeeksDate();
    }
  }

  public onlyMon2Fri = (d: Date | null): boolean => {
    if (!d) {
      return false;
    }
    const day = d.getDay();
    return day >= 1 && day <= 5;
  };

  public onlyMonday = (d: Date | null): boolean => {
    if (!d) {
      return false;
    }
    const day = d.getDay();
    return day === 1;
  };

  public onlyFriday = (d: Date | null): boolean => {
    if (!d) {
      return false;
    }
    const day = d.getDay();
    return day === 0;
  };

  // Refactor this code later
  populateTwoWeeksDate() {
    let minDateTmp: Date = new Date();

    if (this.minDate) {
      minDateTmp = new Date(this.minDate);
    } else if (this.todayDate) {
      minDateTmp = new Date(this.todayDate);
    } else if (this.nextWeekDate) {
      minDateTmp = new Date(this.nextWeekDate);
    }

    this.twoWeeksDate = new Date(minDateTmp);
    this.twoWeeksDate.setDate(minDateTmp.getDate() + 14);
    if (this.twoWeeksDate.getDate() < minDateTmp.getDate()) {
      this.twoWeeksDate.setMonth(minDateTmp.getMonth() + 1);
    } else {
      this.twoWeeksDate.setMonth(minDateTmp.getMonth());
    }

    if (this.twoWeeksDate.getMonth() < minDateTmp.getMonth()) {
      this.twoWeeksDate.setFullYear(minDateTmp.getFullYear() + 1);
    } else {
      this.twoWeeksDate.setFullYear(minDateTmp.getFullYear());
    }
  }

  openPicker() {
    if (this.fromMon2Fri || this.isOnlyMonday || this.isOnlyFriday) {
      if (this.formCtrl) {
        this.dpFormCtrl.open();
      } else {
        this.dpNgModel.open();
      }
    } else {
      if (this.formCtrl) {
        this.dpNoFilterFormCtrl.open();
      } else {
        this.dpNoFilterNgModel.open();
      }
    }
  }

  changeDay(event: any) {
    this.dateChanged.emit(event);
  }
}
